module.exports = __webpack_public_path__ + "images/emoji/sweat_drops.245c349238cdf4f0951b.png";